import Int64LookupResourceListResultModel from '../../generated/types/model/resource/Int64LookupResourceListResultModel';

export default class Int64LookupResourceListResultViewModel extends Int64LookupResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
